//Function to get URL param
function urlParam(name) {
    var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
    if (results==null){
       return null;
    }
    else{
       return results[1] || 0;
    }
}
  
//Function to get cookie value        
function getCookie(cname) {
	var name = cname + "=";
    var ca = document.cookie.split(';');
    for(var i=0; i<ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0)==' ') c = c.substring(1);
      if (c.indexOf(name) != -1) 
        return c.substring(name.length,c.length);
    }
    return "";
}  


//Function to set cookie value   
function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+d.toUTCString();
    document.cookie = cname + "=" + cvalue + "; " + expires;
}
  
//Function to double refresh Cart Page  
function checkReloadCount() {
	if (localStorage.getItem('isLoaded') !== 'yes') {
		localStorage.setItem('isLoaded', 'yes');
      
      	/*var products_cookie = getCookie("products");
      	var products_url = urlParam("products");
      	if(products_url!="" && products_url!=null && products_url!="undefined")
        {
          products_url = products_url.split("-");
          for(x in products_url)
          {
            if(products_cookie.indexOf(products_url[x]) < 0)
            {
              	if(products_cookie == "")
					products_cookie += products_url[x];
              	else
                  	products_cookie += "-" + products_url[x];
            }	
          }
          setCookie("products", products_cookie, 1);
          var str = window.location.href;
          window.location = str.substring(0, str.indexOf("?"));
        }
      	else
        {*/
          location.reload();
        //}
	} else {
      	localStorage.setItem('isLoaded', 'no');
      	//updateCart();
      	removeShipping();
	}
}


//Function to update cart
function removeShipping() {
	$.ajax({
		type: "GET",
		url: "/cart.json",
		success: function(data) 
		{
			var cart_variant = "";
          	var update_qry = "updates[1044261021]=0";
          	var flag = false;
			$.each(data.items, function(idx, obj)
			{
              	if(obj.variant_id == 1044261021)
                {
                  	flag = true;
                  	return false;
                }
			});
          	if(flag)
            {
              	$.ajax({
                    type: "POST",
                    url: "/cart/update.js",
                  	dataType: "html",
                  	data: update_qry,
                    success: function(data) 
                    {
                      	location.reload();
                    }
                });
            }
		}
	});
}


//Function to update cart
function updateCart(URL) {
	$.ajax({
		type: "GET",
		url: "/cart.json",
		success: function(data) 
		{
			var order_variant = getCookie("products").split("-");
          	var cart_variant = "";
          	var update_qry = "";
          	var custom_products = ["Best Dad Case", "Best Mom Case", "Best Mom Ever Case", "Collage 15 Case", "Collage 4 Case", "Collage 6 Case", "Collage 8 Case", "Custom Case", "Film Strip Case", "Image with Background and Subtitle Case", "Image with Background Case", "Personalized Designer Case", "Random 3 Case", "Signature Monogram Case", "Together Forever Case", "We Love You Case", "You & Me Case", "You're Best Case", "You're My Sunshine Case"];
          	var variant = 0;
			$.each(data.items, function(idx, obj)
			{
              	for(x in custom_products)
                {
                	if((obj.title).indexOf(custom_products[x]) >= 0)
                    {
                 		if(cart_variant == "")
                            cart_variant += obj.variant_id;
                        else
                            cart_variant += "," + obj.variant_id;   
                    }
                }
			});
          	if(cart_variant!="")
            {
                cart_variant = cart_variant.split(",");
                for(x in cart_variant)
                {
                    if(order_variant.indexOf(cart_variant[x]) < 0 && cart_variant[x]!="")
                    {	
                        if(update_qry == "")
                            update_qry += "updates["+cart_variant[x]+"]=0";
                        else
                            update_qry += "&updates["+cart_variant[x]+"]=0";
                    }
                }
            }
          	if(update_qry!="")
            {
              	$.ajax({
                    type: "POST",
                    url: "/cart/update.js",
                  	dataType: "html",
                  	data: update_qry,
                    success: function(data) 
                    {
                      	location.reload();
                    }
                });
            }
		}
	});
}
